import React from 'react';
import { useForm } from 'react-hook-form';
import { withTranslation, useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import QuotationImagesList from '../../components/Maintenance/QuotationImagesList';

//Images
import alert from '../../../sass/images/alert/alert.svg';

// Hooks
import useFormInProcess from '../../hooks/useFormInProcess';

function FormInProcess({ id, dataForm, quotation = null, img_quotation = null, km_odometer_service = null, status = null }) {
  const { t } = useTranslation('formInApproval');
  const {
    register,
    handleSubmit,
    errors,
    setValue,
    watch,
  } = useForm({
    mode: 'onChange',
  });

  const {
    handleKmOdometerChange,
    handleImageChange,
    removeImage,
    idService,
    validateFile,
  } = useFormInProcess(id, setValue, watch, dataForm, quotation, img_quotation);

  const images1 = watch(`images1_${idService}`) || [];
  const images2 = watch(`images2_${idService}`) || [];

  return (
    <div className="block-form">
      <form onSubmit={handleSubmit((data) => onSubmit(data))}>
        <div className="col-collapse col-md-12 col-12 none-border">
          {status == 3 ? (
            <p className="txt">{t('title-form_in_approval')} <b>{t('status_in_approval')} </b> {t('title-form_in_approval2')}</p>
          ) : (
            <p className="txt">{t('title2-form_in_approval')} <b>{t('status_in_approval')}</b></p>
          )}
        </div>


        <Row className="no-gutters content_in_process">
          {quotation && status != 3 ? (<QuotationImagesList quotation={quotation} title="Cotización" status={status} />)
            : (
              <Col className="col-collapse" xs={12} sm={12} md={6}>
                <p>{t('quotation')}*</p>
                <input
                  className="form-control inputfile inputfile-1"
                  type="file"
                  id={`images1_${idService}`}
                  name={`images1_${idService}`}
                  multiple
                  accept="image/*,.pdf"
                  capture="environment"
                  {...register(`images1_${idService}`, { required: t('required') })}
                  onChange={(e) => handleImageChange(e, `images1_${idService}`)}
                />
                <label htmlFor={`images1_${idService}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="borrainputfile" width="20" height="17" viewBox="0 0 20 17"><path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"></path></svg>
                  <span className="borrainputfile">{t('select_files')}</span>
                </label>
                <div className='list_items_file'>
                  {images1 && images1.length > 0 && (
                    <ul>
                      {images1.map((file, index) => (
                        <li key={index}>
                          {file.name}{' '}
                          <button
                            type="button"
                            onClick={() => removeImage(`images1_${idService}`, index)} // Pasamos el nombre dinámico del campo
                          >
                            x
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                {errors.images1 && (
                  <div className="error_input">
                    <p>
                      <img src={alert} alt={t('alt:response')} />
                      {errors.images1.message}
                    </p>
                  </div>
                )}
              </Col>
            )}
          {img_quotation && status != 3 ? (<QuotationImagesList quotation={img_quotation} title="Imágenes que concuerden con lo cotizado*" status={status} />)
            : (
              <Col className="col-collapse" xs={12} sm={12} md={6} >
                <p>{t('quotation_img')}*</p>
                <input
                  className="form-control inputfile inputfile-1 "
                  type="file"
                  id={`images2_${idService}`}
                  name={`images2_${idService}`}
                  multiple
                  accept="image/*,.pdf"
                  capture="environment"
                  {...register(`images2_${idService}`, { required: t('required') })}
                  onChange={(e) => handleImageChange(e, `images2_${idService}`)}
                />
                <label htmlFor={`images2_${idService}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="borrainputfile" width="20" height="17" viewBox="0 0 20 17"><path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"></path></svg>
                  <span className="borrainputfile">{t('select_files')}</span>
                </label>
                <div className='list_items_file'>
                  {images2.length > 0 && (
                    <ul>
                      {images2.map((file, index) => (
                        <li key={index}>
                          {file.name} <button type="button" onClick={() => removeImage(`images2_${idService}`, index)}>x</button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                {errors.images2 && (
                  <div className="error_input">
                    <p>
                      <img src={alert} alt={t('alt:response')} />
                      {errors.images2.message}
                    </p>
                  </div>
                )}
              </Col>
            )}
          {validateFile && (
            <div className="error_input">
              <p>
                <img src={alert} alt={t('alt:notification')} />
                {t('Algunos archivos no son válidos. Solo se permiten imágenes (PNG, JPG, JPEG) y PDFs de máximo 6MB.')}
              </p>
            </div>
          )}
          <Col xs={12} sm={12} md={12}>
            <label htmlFor={`kmOdometer_${idService}`} className="col-form-label">
              {t('odometer')} *
            </label>
            <input
              className="form-control"
              type="text"
              name={`kmOdometer_${idService}`}
              placeholder={'00000'}
              defaultValue={km_odometer_service && status != 3 ? km_odometer_service : null}
              disabled={km_odometer_service && status != 3 ? true : false}
              readOnly={km_odometer_service && status != 3 ? true : false}
              onChange={(e) => handleKmOdometerChange(e)}
              ref={register({
                value: true,
                required: true,
              })}
            /> 
          </Col>
        </Row>
      </form>
    </div>
  );
};


FormInProcess.propTypes = {
  t: PropTypes.func.isRequired,
  dataForm: PropTypes.func.isRequired,
  quotation: PropTypes.string,
  img_quotation: PropTypes.string,
  km_odometer_service: PropTypes.string,
  status: PropTypes.number
};

export default withTranslation(['formInApproval', 'alt'])(FormInProcess);
